import { queryClient, trpcClient } from "@/lib/trpc";
import { ensureSession } from "@/lib/auth";
import { getSession, isAuthed } from "@/lib/session";

export interface RouterContext {
  queryClient: typeof queryClient;
  trpcClient: typeof trpcClient;
  getSession: typeof getSession;
  isAuthed: typeof isAuthed;
  ensureSession: typeof ensureSession;
}

export function createRouterContext(): RouterContext {
  return {
    queryClient,
    trpcClient,
    getSession,
    isAuthed,
    ensureSession
  };
}
